<template>
  <div>
    <modal
      :scroll="false"
      :title="modalTitle"
      v-show="isModalVisible"
      @close="closeModal">
      <template #body>
        <ReasonSelectAndComment 
          :showSelectCondition="statusMasterClass === $store.state.statuses.mcStatuses.cancel"
          :rejectionReasons="$store.state.booking.rejectionReasons"
          @changeReason="changeReason" 
          @changeComment="changeComment" 
        />
        </template>
        <template #footer>
          <div class="flex-center">
            <button class="btn btn_blue" :disabled="disableButton" @click="save">{{$t('mc.buttons.save')}}</button>
            <button
              @click="closeModal"
              class="btn btn--transparent btn_cancel">
              {{$t('mc.buttons.cancel')}}
            </button>
          </div>
        </template>
    </modal>
  </div>
</template>


<script>
import ReasonSelectAndComment from "@/components/ReasonSelectAndComment.vue"
export default {
  data() {
    return {
      modalInputsData: {
        comment: '',
        reason: '',
      },
      isModalVisible: false,
    }
  },
  props: {
    studnentReason: {
      type: Boolean,
      required: false
    },
    statusMasterClass: {
      type: String,
      required: false
    }
  },
  components: {
    ReasonSelectAndComment
  },
  computed: {
    //Массив с причинами отмены МК
    rejectionReasons() {
      return this.$store.state.booking.rejectionReasons
    },
    modalTitle() {
      if (this.statusMasterClass === this.$store.state.statuses.mcStatuses.success) return this.$t('mc.modals.titles.mcSuccess')
      if (this.statusMasterClass === this.$store.state.statuses.mcStatuses.cancel && this.studnentReason) return this.$t('mc.modals.titles.mcStudentNotComing')
      else return this.$t('mc.modals.titles.mcNotSuccess')
    },
    disableButton() {
      let isDisable = false
      if (this.statusMasterClass === 'Отменен') {
        if (this.modalInputsData.comment.length > 0 && this.modalInputsData.reason.length > 0) isDisable = false
        else isDisable = true
      }
      else if (this.statusMasterClass === 'Завершен') {
        if (this.modalInputsData.comment.length > 0) isDisable = false
        else isDisable = true
      }
      else isDisable = true
      return isDisable
      //old
      // if (this.statusMasterClass && this.modalInputsData.reason) return false
      // if(!this.statusMasterClass && this.modalInputsData.comment && this.modalInputsData.reason) return false
      // else return true
    }
  },
  methods: {
    openModal() {
      this.isModalVisible = true
    },
    closeModal() {
      this.isModalVisible = false
      for (const prop in this.modalInputsData) this.modalInputsData[prop] = ''
      this.$emit('clearParentsData')
    },
    changeReason(reason) {
      this.modalInputsData.reason = reason.actual
    },
    changeComment(comment) {
      this.modalInputsData.comment = comment
    },
    //Сохранение нового статуса МК
    async save() {
      this.$emit('saveMcData', this.modalInputsData)
      this.closeModal()
    },
  }
}
</script>

<style lang="scss" scoped>
  .mk__select {
    margin-bottom: 30px;
  }
</style>